import { read, utils } from "xlsx";
import LocalizationHelperInstance from "./localizationHelper";
import { TranslationKeys } from "translations";

const CsvImportHelper = {
  decodeBase64: (base64: string) => {
    const cleanedBase64 = base64.replace(/^77u\//, "");
    return atob(cleanedBase64);
  },

  detectDelimiter: (content: string): string => {
    const commaCount = (content.match(/,/g) || []).length;
    const semicolonCount = (content.match(/;/g) || []).length;
    const tabCount = (content.match(/\t/g) || []).length;
    if (commaCount > semicolonCount && commaCount > tabCount) {
      return ",";
    } else if (semicolonCount > commaCount && semicolonCount > tabCount) {
      return ";";
    } else {
      return "\t";
    }
  },

  replaceDelimiter: (content: string, delimiter: string): string => {
    return content.split(delimiter).join(",");
  },

  importCSV: (fileContent: string) => {
    const delimiter = CsvImportHelper.detectDelimiter(fileContent);
    const modifiedContent = CsvImportHelper.replaceDelimiter(fileContent, delimiter);
    const workbook = read(modifiedContent, { type: "string" });

    if (!workbook.SheetNames.length) {
      throw new Error(LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.ImportFileEmpty));
    }

    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = utils.sheet_to_json(worksheet, { header: 1, raw: false });

    if (!jsonData?.length) {
      throw new Error(LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.ImportFileEmpty));
    }

    if (jsonData.length < 2) {
      throw new Error(LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.ImportFileNoData));
    }
    const headers = jsonData[0] as string[];
    return { headers, delimiter };
  },

  getColumnSelectFieldLabel: (label: string) =>
    `${label} ${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ColumnLowerCase)}`,
};

export default CsvImportHelper;
